/* global $ */
import Cookies from 'js-cookie';

class CookieConsent {
  constructor(options = {}) {
    this.config = {
      expireDays: 365,
      cookiePath: '/',
      module: document.querySelector('[data-module*="CookieConsent"]'),
      modal: document.querySelector('[data-module*="CookieModal"]'),
      ...options
    };
  }

  init() {
    const { module, modal, expireDays, cookiePath } = this.config;

    if (!this.config.module) {
      return;
    }

    const isHttps = window.location.protocol === 'https:';

    const setCookies = approvedCookies => {
      if (approvedCookies.length) {
        Cookies.set('png_approvedCookies', approvedCookies.join(','), {
          expires: expireDays,
          path: cookiePath,
          sameSite: isHttps ? 'none' : '',
          secure: isHttps
        });
      }

      window.dataLayer.push({ event: 'cookie_consent_given', data: approvedCookies });
      if (modal) {
        $('#ModalCookies').modal('hide');
        modal.remove();
      }
    };

    const saveRequired = module.querySelectorAll(
      '[data-child-module="CookieConsent__SaveRequired"]'
    );
    const saveChecked = module.querySelectorAll('[data-child-module="CookieConsent__SaveChecked"]');
    const saveAll = module.querySelectorAll('[data-child-module="CookieConsent__SaveAll"]');

    if (!saveChecked) {
      return;
    }

    if (saveRequired) {
      saveRequired.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();

          // get only required inputs (png-functional)
          const cookieInputs = module.querySelectorAll('input[type="checkbox"]:required');

          const approvedCookies = Array.from(cookieInputs).map(checkbox =>
            checkbox.getAttribute('name')
          );

          setCookies(approvedCookies);
        });
      });
    }

    if (saveChecked) {
      saveChecked.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();

          // get only checked inputs (png-functional, but could also be png-analytics)
          const approvedCookies = Array.from(
            module.querySelectorAll('input[type="checkbox"]:checked')
          ).map(checkbox => checkbox.getAttribute('name'));

          setCookies(approvedCookies);
        });
      });
    }

    if (saveAll) {
      saveAll.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();

          // get all inputs
          const cookieInputs = module.querySelectorAll('input[type="checkbox"]');

          // check all inputs (for cookie settings page you want to see these)
          cookieInputs.forEach(input => {
            input.checked = true;
          });

          const approvedCookies = Array.from(cookieInputs).map(checkbox =>
            checkbox.getAttribute('name')
          );

          setCookies(approvedCookies);
        });
      });
    }
  }
}

export default CookieConsent;
